import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { delay, put, takeLeading } from 'redux-saga/effects';

import { fromDto as profileFromDto } from '../../../models/adapters/ProfileAdapter';
import { waitBeforeFetch } from '../../../utils/FetchState';
import { fetchProfile, FetchProfilePayload, profileFetched, profileFetchFailed, ProfileFetchResponsePayload } from '../../actions/setting/fetchProfile';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function createProfileFetchtResponseAction(placeUuid: string, response): Action<ProfileFetchResponsePayload> {
  const { error, profile } = response;
  const timestamp = moment();
  if (!error) {
    return profileFetched({ profile: profileFromDto(profile), timestamp });
  }
  return profileFetchFailed({ placeUuid, timestamp });
}

function* fetchProfileSaga({ payload }: Action<FetchProfilePayload>) {
  const token = yield getAuthenticationToken();
  const { placeUuid, fetchState } = payload;
  const milliseconds = waitBeforeFetch(fetchState);
  yield delay(milliseconds);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.getPlaceProfile, token, { placeUuid });
  const action = createProfileFetchtResponseAction(placeUuid, response);
  yield put(action);
}

export default function* watchFetchProfileSaga() {
  yield takeLeading(fetchProfile, fetchProfileSaga);
}
